<!-- Hero Section with Overlapping Card -->
<section class="mission-hero">
  <div class="hero-background"></div>
  
  <div class="mission-card">
    <h1 class="mission-title">Our Mission</h1>
    <p class="mission-description">
      In a world full of cookie-cutter tours and overcrowded destinations, finding a genuinely 
      unique and local experience can be hard. We built Safroo to solve that.
    </p>
    <p class="mission-secondary">
      We are a community-driven platform dedicated to cutting through the noise and connecting 
      passionate, local guides with curious travelers. We enable real connection, transparent 
      booking, and memories that last long after the trip ends.
    </p>
  </div>
</section>

<!-- Expert Guides Section -->
<section class="expert-guides-section">
  <div class="guides-container">
    <!-- Left Content -->
    <div class="guides-content">
      <h2 class="guides-title">
        <span class="highlight">Safroo Expert guides,</span><br>
        Worlwide
      </h2>
      <p class="guides-description">
        Safroo rigorously vets and verifies all our guides to ensure you're learning from true 
        local experts. Our guides are passionate citizens, historians, chefs, and artists—not 
        just tour operators. They hold the keys to hidden streets, secret recipes, and stories 
        you won't find in any guidebook. We empower them to share their knowledge on their terms, 
        creating the most authentic experiences possible.
      </p>
    </div>

    <!-- Right Images -->
    <div class="guides-images">
      <div class="image-composition">
        <div class="image-wrapper island-image">
          <img src="assets/OurMisson/Island.jpg" alt="Tropical Island" />
        </div>
        <div class="image-wrapper map-image">
          <img src="assets/OurMisson/TouristMap.jpg" alt="Tourist with Map" />
          <div class="image-caption">Your City Awaits</div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Safroo Insights Section -->
<section class="insights-section">
  <h2 class="insights-title">Safroo Insights</h2>
  <div class="insights-container">

    
    <div class="insights-image-wrapper">
      <img src="assets/OurMisson/mobilePhones.svg" alt="Safroo Mobile App Screens" class="phones-image" />
    </div>

  </div>
  

</section>
<div class="insights-content">
  <div class="insights-text-columns">
    <p class="insights-paragraph">
      The core of the Safroo Insight is simple: we don't use complicated computer brains (AI) to guess what you want; we put you in control and rely on real people for quality. Instead of getting lost in thousands of general listings, our platform helps you find exactly what you're looking for using powerful, detailed filters. You can drill down your search not just for a "Food Tour," but for something specific like "Vegan Street Food in Tokyo" or a "History Tour focused on Ancient Architecture." This smart, user-controlled system, called Precision Filtering, is backed by our Safroo Editorial Team. This team manually checks and approves every single experience and guide you see on the app. They look at photos, read descriptions, and verify quality to make sure the listing is authentic, high-quality, and safe. This human check is why Safroo is the best place to find unique local experiences without wasting time on messy, unverified options.
    <p class="insights-paragraph">
      <span class="insights-highlight"></span> Direct Connection, Seamless Booking. The Safroo app is engineered for complete transparency and simplicity. Our unique, three-tap booking process minimizes friction: 1) Check real-time availability using our dynamic calendar, 2) Review the final, all-inclusive price with no hidden fees, and 3) Secure your reservation instantly. All payments are processed securely, and all communication with your verified guide is facilitated directly within the Safroo app. This direct connection ensures easy coordination and personalized service from the moment you book until the experience is complete.	
    </p>
  </div>
</div>

<!-- Why Safroo Section -->
<section class="why-safroo-section">
  <div class="why-safroo-container">
    <!-- Left Images -->
    <div class="why-safroo-images">
      <div class="image-composition">
        <div class="image-wrapper man-island-image">
          <img src="assets/OurMisson/manstandingIsland.svg" alt="Man Standing on Island" />
        </div>
        <div class="image-wrapper why-us-image">
          <img src="assets/OurMisson/Why Us.svg" alt="Why Us" />
          <div class="why-us-text">Why Us?</div>
        </div>
      </div>
    </div>

    <!-- Right Content -->
    <div class="why-safroo-content">
      <h2 class="why-safroo-title">
        Why <span class="highlight">Safroo?</span>
      </h2>
      <p class="why-safroo-description">
        Tired of platforms where quantity trumps quality? Safroo exists to restore genuine connection to travel. We are not just a listing service; we are a curated community committed to delivering the best local experiences.
      </p>
      <p class="why-safroo-description">
        Our differentiation lies in our unique approach to quality control. While other platforms rely on complex, impersonal AI to manage millions of listings, we rely on human expertise and strict standards. Every guide and experience featured on Safroo undergoes a comprehensive, multi-step manual vetting process. We check credentials, assess local expertise, and ensure every activity aligns with our core value of authenticity. This level of oversight guarantees that when you book with Safroo, you are choosing from a high-quality, pre-screened selection, saving you the time and frustration of sifting through thousands of generic, low-effort tours.
      </p>
      <p class="why-safroo-description">
        Furthermore, choosing Safroo is an investment in the local community. We employ a decentralized model that provides our guides with transparent and fair earnings, fostering a passionate community of small business owners. Your payment goes directly to supporting local experts who are proud to share their culture, making your trip meaningful and sustainable. Stop settling for the standard—travel with purpose.
      </p>
    </div>
  </div>
</section>

<!-- Guide Vetting and Vision Section -->
<section class="vetting-vision-section">
  <div class="vetting-vision-container">
    <div class="info-card">
      <img src="assets/OurMisson/leftGroup.svg" alt="Safroo's Guide Vetting Promise" />
    </div>
    <div class="info-card">
      <img src="assets/OurMisson/rightgroup.svg" alt="Our Vision for Travel" />
    </div>
  </div>
</section>
